import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["acronymSelect", "experienceLevelSelect"];

  connect() {
    document.addEventListener("cocoon:before-remove", this.beforeRemove);
    this.validateAll();
  }

  disconnect() {
    document.removeEventListener("cocoon:before-remove", this.beforeRemove);
  }

  // ---------------------------------------------------------------------------
  // QUANDO REMOVE UMA LANGUAGE (Cocoon)
  // ---------------------------------------------------------------------------
  beforeRemove = (e) => {
    const block = e.detail[0]; // .nested-fields

    block.querySelectorAll("input, select, textarea").forEach((el) => {
      el.removeAttribute("required");
      el.classList.remove("is-invalid");
      if (el.name && /\[(id|_destroy)\]$/.test(el.name)) return;
      el.disabled = true;
    });
  };

  // ---------------------------------------------------------------------------
  // MARCAR COMO _destroy = 1
  // ---------------------------------------------------------------------------
  markForDestroy(event) {
    event.preventDefault();

    const wrapper = event.target.closest(".nested-fields");

    const destroyField = wrapper.querySelector("input[name*='[_destroy]']");
    if (destroyField) destroyField.value = "1";

    wrapper.querySelectorAll("[required]").forEach((el) => {
      el.removeAttribute("required");
    });

    // Opção A: Esmaecer o bloco e desabilitar os inputs (preservando id e _destroy para envio no form)
    wrapper.style.opacity = "0.5";
    wrapper.style.pointerEvents = "none";
    wrapper.querySelectorAll("input, select, textarea").forEach((el) => {
      if (el.name && /\[(id|_destroy)\]$/.test(el.name)) return;
      el.disabled = true;
    });

    // Alterar o botão de remoção para estado de processamento
    const removeBtn = event.target.closest("a");
    if (removeBtn) {
      removeBtn.innerHTML = "Removendo... <div class='spinner-border spinner-border-sm text-danger' role='status'></div>";
      removeBtn.style.pointerEvents = "none";
    }
  }

  // ---------------------------------------------------------------------------
  // VALIDAÇÕES
  // ---------------------------------------------------------------------------
  validateAll() {
    this.validateAcronym();
    this.validateExperienceLevel();
  }

  validateAcronym() {
    if (this.acronymSelectTarget.disabled) return;

    if (!this.acronymSelectTarget.value) {
      this.acronymSelectTarget.classList.add("is-invalid");
    } else {
      this.acronymSelectTarget.classList.remove("is-invalid");
    }
  }

  validateExperienceLevel() {
    if (this.experienceLevelSelectTarget.disabled) return;

    if (!this.experienceLevelSelectTarget.value) {
      this.experienceLevelSelectTarget.classList.add("is-invalid");
    } else {
      this.experienceLevelSelectTarget.classList.remove("is-invalid");
    }
  }

  handleFormChange() {
    this.validateAll();
  }
}
